/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class contact extends IceEntity {
  contact_key: string = "";
  communication_number_qualifier: string = "";
  communication_number: string = "";
  communication_type: IceTypes.contacttype = IceTypes.contacttype.ctHome;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  constructor() {
      super();
  }

  gettablename(): string {
      return "CONTACT";
  }
}
